// js
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import Button from '../components/common/Button';
import UsageCard from '../components/usage/UsageCard';
import UsageHeader from '../components/usage/UsageHeader';
import UsageHeaderNav from '../components/usage/UsageHeaderNav';
import UsageStack from './UsageStack';
import dsaView, { defaultPropTypes } from './dsaView';
import ConfirmationModal from '../components/common/ConfirmationModal';


class Usage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rerouteModalOpen: false
    };

    this.closeConfirmRedirect = this.closeConfirmRedirect.bind(this);
    this.openConfirmRedirect = this.openConfirmRedirect.bind(this);
  }

  closeConfirmRedirect() {
    this.setState({ rerouteModalOpen: false });
  }

  openConfirmRedirect() {
    this.setState({ rerouteModalOpen: true });
  }

  render() {
    const { baseNavRoute, areas, area, dsa, subAreas, useQuestions, valueRealized, activeAreaIds, answerDSAUseQuestion, answerDSAValueRealized} = this.props;

    let redirectToGoals = () => {
      browserHistory.push(`${baseNavRoute}/goals`);
    };

    const subArea = subAreas[0];

    return (
      <div className='usage'>
        <div className='container'>
          <section className='content-wrapper'>
            <UsageHeader
              area={area}
              areas={areas}
              activeAreaIds={activeAreaIds}
              baseNavRoute={baseNavRoute}
              dsa={dsa}
            />
            {!area &&
              <div className='text-center'>
                <Button
                  to={`${baseNavRoute}/usage/${activeAreaIds[0] || ''}`}
                  primary
                  disabled={activeAreaIds.length === 0}
                  label='Start'
                />
                <div className='area-cards usage-cards'>
                  {areas.map(area =>
                    (<UsageCard
                      key={area.id}
                      area={area}
                      goalsRedirect={this.openConfirmRedirect}
                    />)
                  )}
                </div>
              </div>
            }
            {!!area &&
              <UsageStack
                area={area}
                areas={areas}
                subArea={subArea}
                subAreas={subAreas}
                useQuestions={useQuestions}
                valueRealized={valueRealized}
                dsaUseQuestions={dsa.dsaUseQuestions}
                dsaValueRealized={dsa.dsaValueRealized}
                answerDSAUseQuestion={answerDSAUseQuestion}
                answerDSAValueRealized={answerDSAValueRealized}
              />
            }
            <UsageHeaderNav
              area={area}
              areas={areas}
              dsa={dsa}
              activeAreaIds={activeAreaIds}
              baseNavRoute={baseNavRoute}
            />
          </section>
        </div>
        <ConfirmationModal
          text='Return to Key Goals to turn on this feature.'
          submitButtonLabel='Go to Key Goals'
          cancelButtonLabel='Stay Here'
          onSubmit={redirectToGoals}
          onCancel={this.closeConfirmRedirect}
          open={this.state.rerouteModalOpen}
        />
      </div>
    );
  }
}

Usage.propTypes = {
  ...defaultPropTypes
};

export default dsaView(Usage);



// WEBPACK FOOTER //
// ./src/containers/Usage.js